import tp from 'shared-tokens/utils/tokens/typography';
import colors from 'shared-tokens/utils/tokens/colors';
import spacings from 'shared-tokens/utils/tokens/spacings';
import createBreakpoint from 'shared-tokens/utils/breakpoints';
const brpS = createBreakpoint('s');

export const mainCls = 'modal-footer';

export default {
    [mainCls]: {
        padding: spacings.s,
        boxShadow: `0 2px 8px 0 ${colors.f3.rgba}`,
    },
    [`${mainCls}--DS`]: {
        padding: `${spacings.s}px ${spacings.m}px`,
        boxShadow: 'none',
        [brpS]: {
            padding: `12px ${spacings.m}px`,
        },
    },
    [`${mainCls}__btncont--confirm`]: {
        flexGrow: 1,
        minWidth: 0,
        width: '100%',
        [brpS]: {
            width: 'auto',
            flexGrow: 0.5,
        },
    },
    [`${mainCls}__btncont--confirm--fw`]: {
        [brpS]: {
            width: 250,
            maxWidth: 250,
        },
    },
    [`${mainCls}__btncont--discard`]: {
        flexGrow: 1,        
        [brpS]: {
            flexGrow: 0,
        },
    },    
    [`${mainCls}__btn`]: {
        [brpS]: {
            height: 32,
            lineHeight: '32px',
        },
    },
    [`${mainCls}__btn--discard`]: {
        fontSize: 15,
        color: `${colors.f5.rgba} !important`,
        borderColor: `${colors.borderdark.rgba} !important`,
        padding: '0 12px !important',
        [brpS]: {
            fontSize: 14,
            borderColor: `${colors.border.rgba} !important`,
            padding: '0 32px !important',
            '&:hover': {
                color: `${colors.secondary.rgba} !important`,
                borderColor: `${colors.borderdark.rgba} !important`,
            },
        },        
    },
    [`${mainCls}__btn--confirm`]: {
        fontFamily: tp.tpFontL,
        width: '100%',
    },
    [`${mainCls}__btncont--confirm--msg`]: {
        fontSize: 14,
        [brpS]: {
            fontSize: 16,
        }
    }
}